/* eslint-disable import/no-relative-packages */
import React, { Fragment } from "react";
import Media from "@qlik/qlik/src/components/Media";
import Cta from "@qlik/qlik/src/components/Cta";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import RichText from "@qlik/qlik/src/components/RichText";
import MarketoForm from "@qlik/qlik/src/components/MarketoForm/MarketoForm";
import { renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";
import * as styles from "./styles.module.css";

const GatedContentSmallForm = ({ data }) => {
    const { backgroundColor, backgroundImage, additionalConfiguration, cardItems = [], customId } = data ?? {};
    const sectionPaddingClassName = getSpacingClassName(additionalConfiguration, "py-15 lg:py-30");
    const { sectionColorMapping } = getColorClassName(backgroundColor);
    return (
        <section
            className={`relative ${sectionPaddingClassName} ${sectionColorMapping.bgColor || "bg-white"} ${
                styles.freeTrailContent
            }`}
            id={customId}
        >
            {backgroundImage?.[0]?.resource_type === "image" && (
                <div className="absolute -z-1 left-0 -top-29.5 md:-left-70 md:-top-11.25 lg:left-0 lg:-top-7 h-full">
                    <Media
                        key={backgroundImage[0].id}
                        link={backgroundImage[0].secure_url}
                        width={backgroundImage[0].width}
                        height={backgroundImage[0].height}
                        className="h-full object-cover"
                    />
                </div>
            )}
            <div className="container">
                <div className="row">
                    {cardItems?.map((card, index) => (
                        <Fragment key={card.id}>
                            {index === 0 ? (
                                <div className="col-12 lg:col-8 lg:pr-11.25">
                                    {card.title && (
                                        <h1
                                            className="title-2" // eslint-disable-next-line react/no-danger
                                            dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(card.title) }}
                                        />
                                    )}
                                    {card?.description && (
                                        <p className="mt-7.5 text-blue">{card.description.description}</p>
                                    )}
                                    {card?.body?.raw && (
                                        <RichText data={card} className={`bodyContent mt-7.5 ${styles.bodyContent}`} />
                                    )}
                                    {card?.cta?.map((link) => (
                                        <Cta key={link.id} data={link} className="mb-7.5 mt-3.75" />
                                    ))}
                                    {card?.media?.[0] && (
                                        <div className="lg:mt-1.25">
                                            <Media
                                                media={card?.media?.[0]}
                                                className="h-auto max-h-225 max-w-88 rounded-sm md:max-w-full"
                                            />
                                            {card?.media?.[0]?.mediaCaptionText && (
                                                <span className="block body text-blue mt-7.5">
                                                    {card?.media?.[0]?.mediaCaptionText}
                                                </span>
                                            )}
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className="col mt-12.5 lg:mt-0">
                                    <div
                                        className={`px-5 py-11 lg:p-10.25 ${
                                            sectionColorMapping.bgColor
                                                ? "bg-white border border-stone/50 rounded shadow-xxl"
                                                : "bg-blue"
                                        }`}
                                    >
                                        <MarketoForm form={card} isDark={!sectionColorMapping?.bgColor} />
                                    </div>
                                </div>
                            )}
                        </Fragment>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default GatedContentSmallForm;
